import { QuickBooksGetProductsResponse, QuickBooksGetProductsResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useQuickbooksEnabled } from './use-quickbooks-enabled';
import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useQuickBooksProducts(
  searchParam?: string,
  options?: CustomUseQueryOptions<QuickBooksGetProductsResponse>,
) {
  const isQuickBooksActivated = useQuickbooksEnabled();

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.quickbooksProducts(...queryDeps),
    async () => {
      const api = getPrivateApi();
      const response = await api.quickbooksGetProducts({ search: searchParam });

      return QuickBooksGetProductsResponseSchema.parse(response);
    },
    {
      ...options,
      enabled: isQuickBooksActivated,
    },
  );
}
